import { render, staticRenderFns } from "./ShowRight.vue?vue&type=template&id=72b1ca04&scoped=true&"
import script from "./ShowRight.vue?vue&type=script&lang=js&"
export * from "./ShowRight.vue?vue&type=script&lang=js&"
import style0 from "./ShowRight.vue?vue&type=style&index=0&id=72b1ca04&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72b1ca04",
  null
  
)

export default component.exports